module.exports = __webpack_public_path__ + "img/1F6B0.9c280bf3.svg";